import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC } from 'react'
import {
  AttributeFilterExternalProps,
  useAttributesFilterProps,
} from './useAttributesFilterProps'

import { useFilterStore } from 'store/sidecar/ProductStreamContext'
import TabSelector from 'uiComponents/organisms/Filters/TabSelector'

export const SpecialSizesSelectorSection: FC<AttributeFilterExternalProps> = ({
  filter,
}) => {
  const { t } = useTranslation()
  const filterStore = useFilterStore()
  const { toggleSelection, ...props } = useAttributesFilterProps(filter, {
    allowOnlyOneSelected: true,
  })

  const defaultSelectionName = t('Alle Größen')

  return (
    <TabSelector
      {...props}
      selectOption={id => {
        toggleSelection(id)
        filterStore.clearFilterGroup('categoryShopFilterSizes')
        filterStore.clearFilterGroup('length')
        filterStore.applyFilter.flush()
      }}
      name={undefined}
      defaultTabName={defaultSelectionName}
    />
  )
}
